import React from "react";
import "../DisclaimerPage/DisclaimerPage.scss";

function DisclaimerPage() {
  return (
    <>
      <div className="disclaimer">
        <h3 className="disclaimer__heading">YouTube Music Disclaimer</h3>
        <p className="disclaimer__description">
          This website is not affiliated with, endorsed by, or sponsored by
          YouTube or YouTube Music in any way. All trademarks, logos, and brand
          names are the property of their respective owners. Music and media
          featured from YouTube or YouTube Music are used for informational,
          educational, or entertainment purposes only and remain the property of
          their original creators. We do not claim ownership of any copyrighted
          material, and all rights belong to the rightful copyright holders. If
          you are a content owner and believe your work has been improperly
          used, please contact us at CelebrationsWithCee@hotmail.com to request
          review or removal. Users are encouraged to access and stream music
          directly through official YouTube or YouTube Music platforms in
          accordance with their Terms of Service.
          {/* or credited */}
        </p>

        <h3 className="disclaimer__heading">
          External Links & Referals Disclaimer
        </h3>
        <p className="disclaimer__description">
          This website may contain links to external sites that are not provided
          or maintained by UnGriefMe. We do not endorse or guarantee the
          accuracy, safety, suitabilit, relevance, or completeness of any
          information on these external websites and are not responsible for
          their content or privacy practices. Use them at your own discretion.
        </p>

        <h3 className="disclaimer__heading">Moderation & removal</h3>
        <p className="disclaimer__description">
          The moderators reserve the right to remove harmful, disrespectful, or
          triggering content to maintain a safe and supportive environment.
          Moderators reserve the right to remove content or participants who
          violate these rules or who pose a safety risk. We may also refuse or
          suspend access at our discretion.
        </p>
        <p className="disclaimer__description">
          Refrain from sharing or requesting medical or therapeutic advice.
          Understand that all discussions are based on personal experience, not
          professional expertise.
        </p>
      </div>
    </>
  );
}

export default DisclaimerPage;
